export default "__VITE_ASSET__DL1y0Z$2__"